/**
 * Created by ejt on 04.10.2016.
 */
'use strict';

angular.module('betosyswebapp')
  .service('toastService', function ($filter, $mdToast) {

    this.showWarningToast = function (msg) {
      $mdToast.show({
        hideDelay: 10000,
        position: 'top right',
        controller: 'ToastErrorCtrl',
        locals: {
          type: 'warning',
          msg: msg
        },
        templateUrl: 'components/common/directives/toastErrorTemplate.tpl.html'
      });
    };


    this.showErrorToast = function (errorAlert) {
      $mdToast.show({
        hideDelay: 10000,
        position: 'top right',
        controller: 'ToastErrorCtrl',
        locals: {
          type: getMessageType(errorAlert.type),
          msg: errorAlert.message
        },
        templateUrl: 'components/common/directives/toastErrorTemplate.tpl.html'
      });
    };

    this.showSuccessToast = function (successMessage) {
      $mdToast.show({
        hideDelay: 5000,
        position: 'top right',
        controller: 'ToastErrorCtrl',
        locals: {
          type: 'success',
          msg: successMessage
        },
        templateUrl: 'components/common/directives/toastErrorTemplate.tpl.html'
      });
    };

    function getMessageType(type) {
      switch (type) {
        case 'M':
          return 'warning';
        case 'W':
          return 'warning';
        case 'F':
          return 'danger';
        default:
          return 'info';
      }
    }


  });



// WEBPACK FOOTER //
// ./.tmp/components/common/services/toastService.js